var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"menu-button",attrs:{"type":"button","aria-label":"Open menu"},on:{"click":function($event){return _vm.$emit('toggle-sidebar')}}},[_c('span',{staticClass:"menu-button__bar"})])
}
var staticRenderFns = []

export { render, staticRenderFns }